"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = processPush;

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

var _renderitemnode = _interopRequireDefault(require("./renderitemnode"));

var _triggerone = _interopRequireDefault(require("../../trigger/_triggerone"));

var _checkalreadyrendered = _interopRequireDefault(require("./checkalreadyrendered"));

var _foreach = _interopRequireDefault(require("../../_helpers/foreach"));

// this function renders inserted items if possible when push method is called
function processPush(_ref) {
  var self = _ref.self,
      selfDef = _ref.selfDef,
      eventOptions = _ref.eventOptions,
      container = _ref.container;
  var added = eventOptions.added,
      silent = eventOptions.silent;
  (0, _foreach["default"])(added, function (item) {
    if (item && (0, _typeof2["default"])(item) === 'object') {
      // if a node of an item is already rendered then throw an error
      (0, _checkalreadyrendered["default"])({
        item: item,
        selfDef: selfDef
      }); // render

      var _renderItemNode = (0, _renderitemnode["default"])({
        selfDef: selfDef,
        self: self,
        item: item,
        eventOptions: eventOptions
      }),
          node = _renderItemNode.node,
          itemEventOptions = _renderItemNode.itemEventOptions;

      if (node) {
        container.appendChild(node);

        if (!silent) {
          (0, _triggerone["default"])(item, 'afterrender', itemEventOptions);
        }
      }
    }
  });
}
//# sourceMappingURL=processpush.js.map